import { observable, action, computed, makeObservable } from 'mobx';
import { http } from 'helpers/HttpApi';
import StoreModel from 'models/Index';

export class KioskReadyStatusModel {
    constructor(public root: StoreModel) {
        makeObservable(this);
    }

    @observable
    public isBatchOpen: boolean = true;

    @action
    setValue(value: any) {
        Object.assign(this, value);
    }

    @action
    checkBatch() {
        const currentBatchId = this.root.batchId;
        const batchId = currentBatchId ?? 0;

        return http
            .get(`/api/transaction/register/batchInfo/${batchId}`)
            .then(({ data }) => {
                this.setValue({
                    isBatchOpen: !!data && data.status.toUpperCase() === 'OPEN',
                });

                return this.isBatchOpen;
            });
    }

    @computed
    get isKioskReady() {
        return this.isBatchOpen;
    }
}

export default KioskReadyStatusModel;
